import {Box, Stack} from '@mui/material';
import {AppointmentBookingEnum} from 'main/analytics/gaTagsEnum';
import {
	AbandonFlowModal,
	MainFooter,
	MainHeader,
	StepProgressBar,
	StyledGrid,
	SwipeableEdgeDrawer,
} from 'presentation/components';
import {CustomStepper} from 'presentation/components/CustomStepper';
import {FlowEnum} from 'presentation/modules/booking/shared/constants/flowEnum';
import {ChangeDialogsGroup} from 'presentation/modules/booking/shared/ui/components/ChangeDialogsGroup';
import {translations} from 'presentation/translations-new';
import React, {Fragment} from 'react';
import {StyledBox} from './styles';
import {useOdontoBooking} from './hooks/useOdontoBooking';
import {OdontoStepsWrapper} from './steps/OdontoStepsWrapper';
import {OdontoSummarySectionGroup} from '../../components/OdontoSummarySectionGroup';
import {OdontoSearchBar} from '../../components/OdontoSearchBar';

const {abandonFlow, appointmentSummary} = translations['pt-br'].privateFlow.bookingFlow;

export function OdontoBooking() {
	const {
		getHeaderTitle,
		handleBack,
		handleClose,
		shouldHideBackBtn,
		isMobile,
		hideStepBar,
		activeBookingFlowStep,
		stepLabels,
		shouldHideSearchBar,
		searchBarTagId,
		searchBarPlaceholder,
		setActiveBookingFlowStep,
		handleConfirmExitFlow,
		abandonFlowState,
		setAbandonFlowState,
		isLastStep,
		showSwipeableDrawerBookingSummary,
		openDrawerState,
		setOpenDrawerState,
		handleChangeModals,
		handleNext,
		customFooterMarginBottom,
		shouldHideSearchBarAndBookingSummary,
		shouldUseNewResumeLayout,
		showOdontoSummarySectionGroupInGrid,
	} = useOdontoBooking();

	return (
		<Fragment>
			<MainHeader
				title={getHeaderTitle()}
				dataTagId={{
					backButton: AppointmentBookingEnum.CLICK_VOLTAR_AGENDAMENTO,
					closeButton: AppointmentBookingEnum.CLICK_DESCARTAR_AGENDAMENTO,
				}}
				handleBack={handleBack}
				handleClose={handleClose}
				hideBackBtn={shouldHideBackBtn}
				variant="subRoute">
				{hideStepBar ? null : (
					<StyledGrid.Root px={isMobile ? 2 : 4} pb={3}>
						<StyledGrid.Item sm={12} md={12} lg={12}>
							<Stack gap={3}>
								{isMobile ? (
									<StepProgressBar
										mt={1}
										currentStep={activeBookingFlowStep + 1}
										totalSteps={stepLabels.length}
									/>
								) : (
									<CustomStepper
										dataTagId={AppointmentBookingEnum.NOME_STEP}
										activeStep={activeBookingFlowStep}
										stepLabels={stepLabels}
									/>
								)}
							</Stack>
						</StyledGrid.Item>
					</StyledGrid.Root>
				)}

				{shouldHideSearchBar ? null : (
					<OdontoSearchBar
						activeStep={activeBookingFlowStep}
						placeholder={searchBarPlaceholder[activeBookingFlowStep]}
						searchDataTagId={searchBarTagId}
					/>
				)}
			</MainHeader>

			<Fragment>
				<StyledGrid.Root p={isMobile ? 2 : 4} height="100%">
					<StyledGrid.Item
						sm={12}
						md={12}
						lg={
							shouldHideSearchBarAndBookingSummary || shouldUseNewResumeLayout
								? 12
								: 8
						}>
						<OdontoStepsWrapper
							activeStep={activeBookingFlowStep}
							handleBack={handleBack}
							handleNext={handleNext}
							stepLabels={stepLabels}
						/>
					</StyledGrid.Item>
					{showOdontoSummarySectionGroupInGrid ? (
						<StyledGrid.Item md={4} lg={4}>
							<OdontoSummarySectionGroup
								activeStep={activeBookingFlowStep}
								handleChangeModals={handleChangeModals}
								stepLabels={stepLabels}
							/>
						</StyledGrid.Item>
					) : null}
				</StyledGrid.Root>

				<StyledBox
					$isLastStep={isLastStep}
					$adjustFooterMargin={shouldHideSearchBarAndBookingSummary}>
					<MainFooter customMarginBottom={customFooterMarginBottom()} />
				</StyledBox>

				{showSwipeableDrawerBookingSummary ? (
					<SwipeableEdgeDrawer
						type="with-appbar"
						title={appointmentSummary}
						open={openDrawerState}
						setOpen={setOpenDrawerState}
						customDrawerHeight={openDrawerState ? 'auto' : undefined}>
						<Box paddingInline={2} paddingBottom={2} height={'100%'} overflow={'auto'}>
							<OdontoSummarySectionGroup
								activeStep={activeBookingFlowStep}
								handleChangeModals={handleChangeModals}
								stepLabels={stepLabels}
								showTitle={false}
								disableGutters={true}
							/>
						</Box>
					</SwipeableEdgeDrawer>
				) : null}
			</Fragment>

			<ChangeDialogsGroup
				flowType={FlowEnum.ODONTO}
				setActiveBookingFlowStep={setActiveBookingFlowStep}
			/>
			<AbandonFlowModal
				open={abandonFlowState}
				setOpen={setAbandonFlowState}
				headerTitle={abandonFlow.headerTitle}
				title={abandonFlow.title}
				description={abandonFlow.description}
				handleConfirm={handleConfirmExitFlow}
				confirmButtondataTagId={AppointmentBookingEnum.ABANDONOU_AGENDAMENTO}
				modaldataTagId={AppointmentBookingEnum.VISUALIZOU_MODAL_ABANDONO}
			/>
		</Fragment>
	);
}
